<template>
	<div
		id="investor-detail"
		:class="[!isWeb ? 'mobile-investor-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToInvestors()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Adicionar Investidor' : 'Editar Investidor' }}
			</h1>
		</div>
		<InvestorForm :isWeb="isWeb" />
		<div class="row column" v-if="$route.query.id">
			<InvestorTab @handleTab="handleTab" />
			<UsersTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@orderByHeader="orderByHeader"
				v-show="selectedTab == 'users'"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_USERS_BY_INVESTOR } from '@/store/modules/investorManagement/actions';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import InvestorForm from '@/components/modules/Investor/InvestorDetail/InvestorForm/InvestorForm.vue';
import InvestorTab from '@/components/modules/Investor/InvestorDetail/InvestorTab/InvestorTab.vue';
import UsersTable from '@/components/modules/Investor/InvestorDetail/UsersTable/UsersTable.vue';

export default {
	name: 'InvestorDetail',
	components: { SidebarArrow, InvestorForm, InvestorTab, UsersTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		headerSelected: null,
		orderSelected: null,
		selectedTab: 'users',
	}),
	created() {
		if (this.$route.query.id) {
			this.refreshUsers();
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('investorManagement', {
			getInvestorUsers: GET_USERS_BY_INVESTOR,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToInvestors() {
			this.$router.push({ path: '/dashboard/investors' });
		},
		handleTab(param) {
			this.selectedTab = param;
			this.page = 1;
			this.headerSelected = null;
			this.orderSelected = null;
			this.refreshUsers();
		},
		changePage(params) {
			this.page = params.params;
			this.refreshUsers();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshUsers();
		},
		refreshUsers() {
			const id = this.$route.query.id;
			let params = `?limit=20&page=${this.page}`;

			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getInvestorUsers({ vm: this, id: id, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'InvestorDetail.scss';
</style>
